// src/widgets/table/TableServerCommand.ts
/**
 * Серверные команды для TableWidget.
 * Используются в TableServerCmdProvider.
 */
var TableServerCommand;
(function (TableServerCommand) {
    /** Перезагрузить тело таблицы по tableKey */
    TableServerCommand["reloadTable"] = "reloadTable";
})(TableServerCommand || (TableServerCommand = {}));

export { TableServerCommand };
